import { Component, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '../../../../core/animations';
import { MatSnackBar } from '@angular/material';


@Component({
    selector: 'toast',
    template: '',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ToastComponent {

    constructor(
        public snackBar: MatSnackBar

    ) {
    }

    //Toast message 
    showToast(message) {
        this.snackBar.open(message, 'Ok', {
            verticalPosition: 'top',
            duration: 2000
        });
    }
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/common/toast.component.ts